import React, { useState, useEffect } from 'react';

/**
 * Component to render a local image (a Blob or File) passed in as src. Manages converting the
 * Blob/File to a local URL and then cleaning it up.
 */
const LocalFileImage = ({ src, ...props }) => {
  const [url, setUrl] = useState();
  useEffect(() => {
    const newUrl = URL.createObjectURL(src);
    setUrl(newUrl);
    return () => URL.revokeObjectURL(newUrl);
  }, [src]);

  return url ? <img src={url} {...props} /> : null;
};

export default LocalFileImage;
